import Control from '@/Controls/Control';
import ExpanderBoxViewModel from '@/ViewModels/Controls/ExpanderBoxViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LinkT from '@/Controls/Link';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class ExpanderBox extends Control {
    public context: ExpanderBoxViewModel;

    private Link = ComponentManager.getControl<typeof LinkT>('Link');

    private control: JQuery;
    private content: JQuery;

    constructor(private viewModel: ExpanderBoxViewModel, private element: JQuery) {
        super(viewModel, element);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.control != null) {
            return this.control;
        }

        this.control = this.element || $('<div>');

        this.applyBindings(this.control, {
            controlName: 'expanderbox',
            loader: this.context.isBusy,
            controlIdent: this.identifier,
            states: this.definePureComputed({
                read: () => {
                    return this.viewModel.isCollapsed() ? ['collapsed'] : ['expanded'];
                }
            }),
            visible: this.context.isVisible(),
            attr: {
                role: 'group'
            }
        });

        this.applyBindings(this.control.find('.c-content'), {
            slide: this.definePureComputed({
                read: () => {
                    return {
                        value: !this.context.isCollapsed(),
                        onSlideDown: (content) => {
                            content.find('.k-splitter').each(function () {
                                $(this).resize();
                            });
                        }
                    };
                }
            })
        });

        if (this.viewModel.link != null) {
            const link = new this.Link(this.viewModel.link, $('<span>').prependTo(this.control));
            const tuple = link.getTuple();

            this.applyBindings(tuple.control, {
                attr: {
                    role: 'heading',
                    'aria-level': this.viewModel.level
                }
            });
        }

        return this.control;
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setControl('ExpanderBox', ExpanderBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');